import script from "./ClassDivisionWorkspace.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassDivisionWorkspace.vue?vue&type=script&setup=true&lang=js"

import "./ClassDivisionWorkspace.vue?vue&type=style&index=0&id=89c2a46e&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/AIDean/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89c2a46e"]])

export default __exports__